import CommonModal from '@/component/pools/modal/CommonModal';
import { isCompleteModalType } from '@/types';
import { useEffect, useState } from 'react';
import { Typography, useTheme } from '@mui/material';
import { STATE_STAKE } from './common/name-space/status';

type ResultPopupProps = {
  isCompleteModal: isCompleteModalType;
  triggerIsCompleteModal: (key: keyof isCompleteModalType) => void;
  errorMsg?: string;
  type?: STATE_STAKE;
  setIsRetry?: (value: boolean) => void;
  // isRetry?: boolean;
};

export default function ResultPopup({
  isCompleteModal,
  triggerIsCompleteModal,
  errorMsg,
  type,
  setIsRetry,
}: // isRetry,
ResultPopupProps) {
  const [msg, setMsg] = useState('');
  useEffect(() => {
    switch (type) {
      case STATE_STAKE.STAKE:
        setMsg('Staking');
        break;
      case STATE_STAKE.UNSTAKE:
        setMsg('Unstake');
        break;
      case STATE_STAKE.CLAIM:
        setMsg('Claim');
        break;
      case STATE_STAKE.WITHDRAW:
        setMsg('Withdraw');
        break;
      case STATE_STAKE.PENDING:
        setMsg('Retry');
        break;
      default:
        break;
    }

    return () => {};
  }, [type]);

  const theme = useTheme();

  const getTitle = () => {
    return `${msg} Complete`;
  };
  return (
    <>
      {/*  Confirm 성공 시 */}
      <CommonModal
        open={isCompleteModal.success}
        handleClose={() => {
          triggerIsCompleteModal('success');
        }}
        title={getTitle()}
        type="success"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          {msg} Completed Successfully.
          <br />
          Thank You.
        </Typography>
      </CommonModal>
      {/*  Confirm 실패 시 */}
      <CommonModal
        open={isCompleteModal.fail}
        handleClose={() => {
          triggerIsCompleteModal('fail');
        }}
        title="Error"
        type="error"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          {msg} Fail
          <br />
          {errorMsg}
        </Typography>
      </CommonModal>
      {/*  Confirm 알림 시 */}
      <CommonModal
        open={isCompleteModal.notice ?? false}
        handleClose={() => {
          triggerIsCompleteModal('notice');
        }}
        title="Notice"
        type="error"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          {msg} Notice
          <br />
          {errorMsg}
        </Typography>
      </CommonModal>

      {/*  Confirm 재시도 */}
      <CommonModal
        open={isCompleteModal.pending ?? false}
        handleClose={() => {
          triggerIsCompleteModal('pending');
          setIsRetry && setIsRetry(true);
        }}
        title="retry"
        type="error"
      >
        <Typography color={theme.greyscale.grey2} variant="h6">
          {msg}
          <br />
          {errorMsg}
        </Typography>
        <Typography color={theme.background.green}>
          Press the OK button to expedite the transaction and proceed again.
        </Typography>
      </CommonModal>
    </>
  );
}
